import { render, staticRenderFns } from "./GetApps.vue?vue&type=template&id=04ad105e&scoped=true"
import script from "./GetApps.vue?vue&type=script&lang=js"
export * from "./GetApps.vue?vue&type=script&lang=js"
import style0 from "./GetApps.vue?vue&type=style&index=0&id=04ad105e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad105e",
  null
  
)

export default component.exports